'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_NotAnEPSCodeError(code) {
  this.Lapp_data_NotAnEPSCodeError__f_code = null;
  this.Lapp_data_NotAnEPSCodeError__f_code = code;
}
export { $c_Lapp_data_NotAnEPSCodeError as $c_Lapp_data_NotAnEPSCodeError };
$c_Lapp_data_NotAnEPSCodeError.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_NotAnEPSCodeError.prototype.constructor = $c_Lapp_data_NotAnEPSCodeError;
/** @constructor */
function $h_Lapp_data_NotAnEPSCodeError() {
}
export { $h_Lapp_data_NotAnEPSCodeError as $h_Lapp_data_NotAnEPSCodeError };
$h_Lapp_data_NotAnEPSCodeError.prototype = $c_Lapp_data_NotAnEPSCodeError.prototype;
$c_Lapp_data_NotAnEPSCodeError.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_NotAnEPSCodeError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1158662177, true);
});
$c_Lapp_data_NotAnEPSCodeError.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_NotAnEPSCodeError) && (this.Lapp_data_NotAnEPSCodeError__f_code === x$0.Lapp_data_NotAnEPSCodeError__f_code)));
});
$c_Lapp_data_NotAnEPSCodeError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_data_NotAnEPSCodeError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_data_NotAnEPSCodeError.prototype.productPrefix__T = (function() {
  return "NotAnEPSCodeError";
});
$c_Lapp_data_NotAnEPSCodeError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_data_NotAnEPSCodeError__f_code;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_NotAnEPSCodeError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "code";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_NotAnEPSCodeError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_data_NotAnEPSCodeError)));
}
export { $isArrayOf_Lapp_data_NotAnEPSCodeError as $isArrayOf_Lapp_data_NotAnEPSCodeError };
var $d_Lapp_data_NotAnEPSCodeError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_NotAnEPSCodeError, "app.data.NotAnEPSCodeError", ({
  Lapp_data_NotAnEPSCodeError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_data_NotAnEPSCodeError as $d_Lapp_data_NotAnEPSCodeError };
//# sourceMappingURL=app.data.-Not-An-E-P-S-Code-Error.js.map
